import "./Home.module.css";
import { useEffect } from 'react';
import Header from "@/reusable_sections/Header";
import BreakingAndUpdate from "./sections/BreakingAndUpdate";
import Hero from "./sections/Hero";
import LiveUpdateCepat from "./sections/LiveUpdateCepat";
import ZonaPemudaPancasila from "./sections/ZonaPemudaPancasila";
import NewsGrid from "./sections/NewsGrid";
import Clarification from "./sections/Clarification";
import RegionalNews from "./sections/RegionalNews";
import OpinionAndFeature from "./sections/OpinionAndFeature";
import Livenewstickerbar from "./sections/Livenewstickerbar";
import Analyticsdashboard from "./sections/Analyticsdashboard";
import GlossyBottomNavigation from "./sections/GlossyBottomNavigation";
export default function HomePage() {
  const schemaData = {
    "@context": "https://schema.org",
    "@graph": [{
      "@type": ["Organization", "NewsMediaOrganization"],
      "@id": "https://abadi.news/#organization",
      "name": "ABADI.NEWS",
      "url": "https://abadi.news",
      "logo": {
        "@type": "ImageObject",
        "url": "https://abadi.news/logo.png"
      },
      "contactPoint": {
        "@type": "ContactPoint",
        "contactType": "customer service",
        "url": "https://abadi.news/contact"
      }
    }, {
      "@type": "WebSite",
      "@id": "https://abadi.news/#website",
      "url": "https://abadi.news",
      "name": "ABADI.NEWS",
      "publisher": {
        "@id": "https://abadi.news/#organization"
      },
      "potentialAction": {
        "@type": "SearchAction",
        "target": "https://abadi.news/search?q={search_term_string}",
        "query-input": "required name=search_term_string"
      }
    }, {
      "@type": "BreadcrumbList",
      "@id": "https://abadi.news/#breadcrumb",
      "itemListElement": [{
        "@type": "ListItem",
        "position": 1,
        "item": {
          "@id": "https://abadi.news",
          "name": "Home"
        }
      }]
    }]
  };
  useEffect(() => {
    document.title = "ABADI.NEWS | Media Nasional, Daerah & Pemuda Pancasila";
    let metaDescription = document.querySelector('meta[name="description"]');
    if (!metaDescription) {
      metaDescription = document.createElement('meta');
      metaDescription.setAttribute('name', 'description');
      document.head.appendChild(metaDescription);
    }
    metaDescription.setAttribute('content', "ABADI.NEWS menyajikan berita nasional, daerah, pemerintahan, hukum, ekonomi, komunitas, organisasi, UMKM, teknologi, serta informasi Pemuda Pancasila secara cepat, akurat dan terpercaya.");
    let ogTitle = document.querySelector('meta[property="og:title"]');
    if (!ogTitle) {
      ogTitle = document.createElement('meta');
      ogTitle.setAttribute('property', 'og:title');
      document.head.appendChild(ogTitle);
    }
    ogTitle.setAttribute('content', "ABADI.NEWS | Media Nasional, Daerah & Pemuda Pancasila");
    let ogDescription = document.querySelector('meta[property="og:description"]');
    if (!ogDescription) {
      ogDescription = document.createElement('meta');
      ogDescription.setAttribute('property', 'og:description');
      document.head.appendChild(ogDescription);
    }
    ogDescription.setAttribute('content', "ABADI.NEWS menyajikan berita nasional, daerah, pemerintahan, hukum, ekonomi, komunitas, organisasi, UMKM, teknologi, serta informasi Pemuda Pancasila secara cepat, akurat dan terpercaya.");
    let ogType = document.querySelector('meta[property="og:type"]');
    if (!ogType) {
      ogType = document.createElement('meta');
      ogType.setAttribute('property', 'og:type');
      document.head.appendChild(ogType);
    }
    ogType.setAttribute('content', 'website');
    let ogUrl = document.querySelector('meta[property="og:url"]');
    if (!ogUrl) {
      ogUrl = document.createElement('meta');
      ogUrl.setAttribute('property', 'og:url');
      document.head.appendChild(ogUrl);
    }
    ogUrl.setAttribute('content', 'https://abadi.news');
    let existingScript = document.querySelector('script[type="application/ld+json"]');
    if (existingScript) {
      existingScript.remove();
    }
    const schemaScript = document.createElement('script');
    schemaScript.type = 'application/ld+json';
    schemaScript.textContent = JSON.stringify(schemaData);
    document.head.appendChild(schemaScript);
    return () => {
      if (schemaScript && schemaScript.parentNode) {
        schemaScript.parentNode.removeChild(schemaScript);
      }
    };
  }, []);
  return <div>
      <div className="fixed top-0 left-0 right-0 z-[99999] w-full">
        <Header />
        <Livenewstickerbar />
      </div>
      <main className="pt-[110px]">
        <BreakingAndUpdate />
        <Hero />
        <LiveUpdateCepat />
        <ZonaPemudaPancasila />
        <NewsGrid />
        <Clarification />
        <RegionalNews />
        <OpinionAndFeature />
        <Analyticsdashboard />
        <GlossyBottomNavigation />
      </main>
    </div>;
}